<template>
    <ul class="list-group" id="sidebar">
        <li class="list-group-item">
            <strong>Jolly Ryans</strong>
            <div>Office : <strong>(415) 230-5328</strong></div>
            <div>Cell : <strong>(415) 412-1102</strong></div>
            <div>Fax : <strong>(866) 571-6508</strong></div>
            <div>License # : <strong>01239184</strong></div>
            <a href= "mailto:jolly@jollyryans.com">jolly@jollyryans.com</a>
        </li>
        <router-link to="/" tag="li" class="list-group-item" activeClass="active" exact>
            <a>
                Home
            </a>
        </router-link>
        <router-link to="/about" tag="li" class="list-group-item" activeClass="active">
            <a>
                About Jolly Ryans
            </a>
        </router-link>
        <router-link to="/listings/available" tag="li" class="list-group-item" activeClass="active" v-if="availableListings.length > 0">
            <a>
                Available Listings
            </a>
        </router-link>
        <router-link to="/listings/sold" tag="li" class="list-group-item" activeClass="active">
            <a>
                Sold Listings
            </a>
        </router-link>
        <router-link to="/listings/all" tag="li" class="list-group-item" activeClass="active">
            <a>
                All Listings
            </a>
        </router-link>
        <router-link to="/mortgagecalculator" tag="li" class="list-group-item" activeClass="active">
            <a>
                Mortgage Calculator
            </a>
        </router-link>
        <li class="list-group-item">
            <a href= "http://money.cnn.com/real_estate/index.html">Real Estate News</a>
        </li>
        <li class="list-group-item">
            <a href= "http://www.city-data.com/city/California.html">California City Profiles</a>
        </li>
        <li class="list-group-item">
            <a href= "http://nces.ed.gov/globallocator/index.asp?search=1&zipcode=94105&State=CA&city=San+Francisco&School=1&PrivSchool=1&College=1&Library=1&CS=CFE4C1E">School Information</a>
        </li>
        <router-link to="/foreclosure" tag="li" class="list-group-item" activeClass="active">
            <a>
                Foreclosure Avoidance
            </a>
        </router-link>
        <li class="list-group-item eurus-image" id="eurus-image">
            <img src="../assets/eurus.jpg" alt="Eurus Corp" width="100%"/>
        </li>
        <router-link to="/buyerscenter" tag="li" class="list-group-item eurus-mobile-only" activeClass="active">
            <a>Buyer's Center</a>
        </router-link>
        <router-link to="/sellerscenter" tag="li" class="list-group-item eurus-mobile-only" activeClass="active">
            <a>Seller's Center</a>
        </router-link>
    </ul>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    export default {
        computed: {
            ...mapGetters([
                'availableListings'
            ])
        },
        methods: {
            ...mapActions([
                'loadListings'
            ])
        },
        created() {
            this.loadListings();
        }

    }

</script>

<style>
    .eurus-mobile-only {
        visibility: hidden;
    }
    @media (max-width:767px) {
        .eurus-mobile-only {
            visibility: visible;
        }
    }
</style>


// WEBPACK FOOTER //
// Sidebar.vue?bdef9a32